export enum ViewTable {
  Week = 'week',
  Month = 'month',
}
